import { Layout } from '@/components/layout/Layout';
import { motion } from 'framer-motion';
import { FileText, MapPin } from 'lucide-react';

const TermsOfServicePage = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-4">
              <div className="p-3 bg-primary/10 rounded-full">
                <FileText className="h-8 w-8 text-primary" />
              </div>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Terms of Service â€“ <span className="text-gradient-rainbow">JoyAura</span>
            </h1>
            <p className="text-muted-foreground text-lg">
              Last updated on 3 January 2026
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none space-y-8">
            <div className="bg-card border rounded-lg p-6">
              <p className="text-muted-foreground mb-4">
                These Terms of Service govern your access to and use of the JoyAura platform,
                including the JoyAura mobile application and the website
                <strong> JoyAurafashion.com</strong>.
              </p>

              <p className="text-muted-foreground mb-4">
                <strong>
                  JoyAura is owned and operated by Papisetti Subbaiah, a sole proprietorship
                  registered in India.
                </strong>
              </p>

              <p className="text-muted-foreground">
                By accessing or using the JoyAura platform, you agree to comply with and be
                bound by these Terms of Service.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold mb-4">1. Platform Overview</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>
                  â€¢ JoyAura is an online fashion marketplace where third-party sellers list and
                  sell products. JoyAura also operates its own in-house fashion brand JoyAura.
                </li>
                <li>
                  â€¢ JoyAura facilitates transactions between customers and sellers but does not
                  manufacture most products listed by independent sellers.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. User Eligibility</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>â€¢ Users must be at least 18 years old</li>
                <li>â€¢ Accurate and complete information must be provided during registration</li>
                <li>â€¢ Users are responsible for maintaining the confidentiality of their account credentials</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Orders & Payments</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>â€¢ All orders are subject to seller acceptance</li>
                <li>â€¢ Prices, availability, and delivery timelines may vary by seller and location</li>
                <li>â€¢ Payments are processed through authorized and secure payment gateways</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Cancellation Policy</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>â€¢ Orders may be cancelled within 1 day of placement or before shipping, whichever occurs earlier</li>
                <li>â€¢ Once an order is shipped, cancellation is not permitted</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Seller Responsibilities</h2>
              <p className="mb-4">Sellers on JoyAura must:</p>
              <ul className="space-y-2 text-muted-foreground">
                <li>â€¢ List genuine and quality-checked products</li>
                <li>â€¢ Provide accurate product descriptions and images</li>
                <li>â€¢ Fulfill orders within committed timelines</li>
                <li>â€¢ Follow JoyAuraâ€™s quality, compliance, and marketplace standards</li>
              </ul>
              <p className="text-muted-foreground mt-4">
                JoyAura reserves the right to suspend or terminate seller accounts for violations
                of platform policies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Intellectual Property</h2>
              <p className="text-muted-foreground">
                All content, trademarks, logos, and branding including JoyAura and JoyAura are the
                intellectual property of JoyAura or its licensors. Unauthorized use is prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Limitation of Liability</h2>
              <p className="mb-4">JoyAura shall not be liable for:</p>
              <ul className="space-y-2 text-muted-foreground">
                <li>â€¢ Product defects attributable to independent sellers</li>
                <li>â€¢ Delays or failures caused by logistics partners</li>
                <li>â€¢ Events beyond reasonable control (force majeure)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Governing Law & Jurisdiction</h2>
              <div className="bg-secondary/50 rounded-lg p-6">
                <p className="text-muted-foreground">
                  These Terms of Service are governed by the laws of India, with exclusive
                  jurisdiction in Chennai, Tamil Nadu.
                </p>

                <div className="mt-4 pt-4 border-t border-border/50">
                  <div className="flex items-start gap-2 text-muted-foreground">
                    <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium mb-1">Registered Address:</p>
                      <p>1B, Anna Street, Ram Nagar, Ambattur OT,</p>
                      <p>Chennai, Tamil Nadu â€“ 600053</p>
                    </div>
                  </div>

                  <p className="text-sm text-muted-foreground mt-3">
                    Proprietor: <strong>Papisetti Subbaiah</strong>
                  </p>

                  <p className="text-sm text-muted-foreground">
                    Udyam Registration Number: UDYAM-TN-02-0426745
                  </p>
                </div>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </Layout>
  );
};

export default TermsOfServicePage;
